module.exports = {"220105001":"东盛街道","220105002":"吉林街道","220105003":"荣光街道","220105004":"东站街道","220105005":"远达街道","220105006":"八里堡街道","220105007":"长青街道","220105100":"英俊镇","220105173":"劝农山镇","220105174":"泉眼镇","220105270":"四家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220105.json
// module id = 694
// module chunks = 0